<template>
	<div class="line-matching-control" ref="ctrl">
		<div ref="canvas-container" class="conn-canvas" @click.stop="cancelConnecting" />
		<el-button
			v-show="selectedLine"
			:style="selectedLineRemoverPosition"
			circle
			class="canvas-line-remover"
			@click="onRemoveLineBtn"
			size="mini"
			type="danger"
			icon="el-icon-close"
		></el-button>
		<template>
			<div class="items-area left-area" ref="monitor-box-left">
				<div
					:class="{
						'connect-mode-item': true,
						'wrong-answered': isWrongAnsweredLeftArea(idx),
						active: isKnobActive('left', idx)
					}"
					v-for="(item, idx) in leftItems"
					:key="idx"
				>
					<div class="item" v-html="item"></div>
					<div class="knob" @click.stop="onClickKnob('left', idx)">
						<span
							:class="{ circle: true, active: isKnobActive('left', idx) }"
							@mouseenter="onKnobEnter('left', idx)"
							ref="knob_left"
						></span>
					</div>
				</div>
			</div>
			<div class="items-area right-area" ref="monitor-box-right">
				<div
					:class="{
						'connect-mode-item': true,
						'wrong-answered_right': isWrongAnsweredrightArea(idx),
						active: isKnobActive('right', idx)
					}"
					v-for="(item, idx) in rightItems"
					:key="idx"
				>
					<div class="knob" @click.stop="onClickKnob('right', idx)">
						<span
							:class="{ circle: true, active: isKnobActive('right', idx) }"
							@mouseenter="onKnobEnter('right', idx)"
							ref="knob_right"
						></span>
					</div>
					<div class="item" v-html="item"></div>
				</div>
			</div>
		</template>
	</div>
	<!-- <div v-if="disabled" class="line-matching-answered-tips">
			<div class="cell">
				<svg class="icon" aria-hidden="true">
					<use xlink:href="#icon-iconoutlineline"></use>
				</svg>
				<span>正确连线</span>
			</div>
			<div class="cell wrong">
				<svg class="icon" aria-hidden="true">
					<use xlink:href="#icon-iconoutlineline"></use>
				</svg>
				<span>错误连线</span>
			</div>
			<div class="cell miss">
				<svg class="icon" aria-hidden="true">
					<use xlink:href="#icon-iconoutlinedottedline"></use>
				</svg>
				<span>遗漏连线</span>
			</div>
		</div> -->
</template>

<script>
import Konva from 'konva'
import cloneDeep from 'lodash/cloneDeep'
import lodash from 'lodash'
import elementResizeDetectorMaker from 'element-resize-detector'
// const OUT_REACH = 20;
// const ARC_RAD = 15;
//const SPLINE_MIDPOINT_OFFSET_RATE = ;

export default {
	props: {
		// 左右纯数据
		items: {
			default: () => {
				return {
					left: [],
					right: []
				}
			},
			type: Object
		},
		// 左右关系对应
		connections: {
			default: () => {
				return [[], []]
			},
			type: Array
		},
		// true编辑 false查看
		itemsEditable: {
			type: Boolean,
			default: true
		},
		// 禁用线编辑
		disabled: {
			default: false,
			type: Boolean
		},
		standardAnswer: Array,
	},
	computed: {
		leftItems() {
			if (!this.items || !this.items.left) return []
			return this.items.left
		},
		rightItems() {
			if (!this.items || !this.items.right) return []
			return this.items.right
		},
		expanedConnections() {
			let out = []
			if (this.connections) {
				this.connections.forEach((outterEl, k) => {
					outterEl.forEach(el => {
						out.push([k, el])
					})
				})
			}
			return out
		},
		expaneStandardAnswerConnections() {
			let out = []
			if (this.standardAnswer) {
				this.standardAnswer.forEach((outterEl, k) => {
					outterEl.forEach(el => {
						out.push([k, el])
					})
				})
			}
			return out
		},
		jsonedConnections() {
			return JSON.stringify(this.connections)
		},
		jsonedItems() {
			return JSON.stringify(this.items)
		},
		selectedLineRemoverPosition() {
			if (!this.selectedLine) return ''
			let points = this.selectedLine.points()

			let x = Math.round((points[0] + points[points.length - 2]) / 2)
			let y = Math.round((points[1] + points[points.length - 1]) / 2)

			// 计算icon左上角
			x -= 14
			y -= 14

			return `left: ${x}px; top: ${y}px`
		}
	},
	data() {
		return {
			connectingKnob: null,
			canvasWidth: 100,
			canvasHeight: 100,
			connectingStartPoint: null,
			connectingFromArea: null,
			omitConnections: null,
			wrongConnections: null,
			canvasStage: null,
			canvasLayer: null,
			canvasTempLine: null,
			selectedLine: null,
			canvasBackPanel: null
		}
	},
	mounted() {
    const delayRender = () => {
      this.canvasWidth = this.$refs.ctrl.clientWidth
      this.canvasHeight = this.$refs.ctrl.clientHeight
      if (this.canvasWidth == 0 || this.canvasWidth == undefined) {
        setTimeout(delayRender, 100)
      } else {
        let erd = elementResizeDetectorMaker()
        if (!this.itemsEditable) {
          console.log('为了杜绝报错~')
          ;['monitor-box-left', 'monitor-box-right'].forEach(el => {
            erd.listenTo(this.$refs[el], () => {
              if (this.$refs.ctrl) {
                this.canvasWidth = this.$refs.ctrl.clientWidth
                this.canvasHeight = this.$refs.ctrl.clientHeight
                //执行操作
                this.initCanvas()
              }
            })
          })
        }
        this.initCanvas()
        document.body.addEventListener('click', () => {
          this.cancelConnecting()
        })
      }
    }
    delayRender()
	},
	components: {},
	watch: {
		jsonedConnections() {
			// 这里不能设置immediate，因为刚进来的时候，canvas还没ready
			this.updateConnectionLines()
		},
		jsonedItems: {
			handler() {
				// nextTick等待DOM完成调整，才能获取到新的knob位置
				this.$nextTick(() => {
					// 刷新一下，因为增删item可能会引起canvas的height的变化
					this.canvasWidth = this.$refs.ctrl.clientWidth
					this.canvasHeight = this.$refs.ctrl.clientHeight

					this.canvasStage.width(this.canvasWidth)
					this.canvasStage.height(this.canvasHeight)

					if (this.canvasBackPanel) {
						this.canvasBackPanel.width(this.canvasWidth)
						this.canvasBackPanel.height(this.canvasHeight)
					}

					this.updateConnectionLines()
				})
			},
			immediate: true
		}
	},
	methods: {
		cancelConnecting() {
			if (this.disabled) return

			if (this.connectingKnob) {
				// 现在总是先删除临时线
				if (this.canvasTempLine) {
					this.canvasTempLine.destroy()
					this.canvasStage.draw()
				}
				// 清理连接中状态
				this.connectingKnob = null
				this.connectingStartPoint = null
				this.connectingFromArea = null

				// 解除事件
				this.canvasStage.off('mousemove', this.onCanvasMouseMove)
			}
		},
		isWrongAnsweredLeftArea(leftAreaIndex) {
			if (!this.standardAnswer) return false // 无提供标准答案，不算错

			if (!this.connections) return true // 空白卷
			// 比较
			if (this.connections[leftAreaIndex].length !== this.standardAnswer[leftAreaIndex].length) return true

			if (
				lodash.uniq(this.connections[leftAreaIndex].concat(this.standardAnswer[leftAreaIndex])).length ===
				this.standardAnswer[leftAreaIndex].length
			) {
				return false
			} else {
				return true
			}
		},
		isWrongAnsweredrightArea(rightAreaIndex) {
			if (!this.standardAnswer) return false // 无提供标准答案，不算错

			if (!this.connections) return true // 空白卷

			let wrongArray = []

			if (this.wrongConnections) {
				this.wrongConnections.forEach(el => {
					wrongArray.push(el[1])
				})
			}

			if (this.omitConnections) {
				this.omitConnections.forEach(el2 => {
					wrongArray.push(el2[1])
				})
			}
			wrongArray = lodash.uniq(wrongArray)

			return wrongArray.some(el3 => {
				return el3 == rightAreaIndex
			})
		},
		convertToMappedConnection(arrConections) {
			let answerObj = []

			// 先填充
			this.leftItems.forEach(el => answerObj.push([]))

			// 填入
			arrConections.forEach(el => answerObj[el[0]].push(el[1]))
			return answerObj
		},
		initCanvas() {
			this.canvasStage = new Konva.Stage({
				container: this.$refs['canvas-container'],
				width: this.canvasWidth,
				height: this.canvasHeight
			})

			this.canvasLayer = new Konva.Layer()
			this.canvasStage.add(this.canvasLayer)

			// this.$emit('updateParentHeight', this.$refs.ctrl.clientHeight)

			// 上个透明背板，否则无法响应点击
			if (!this.disabled) {
				this.canvasBackPanel = new Konva.Rect({
					x: 0,
					y: 0,
					width: this.canvasWidth,
					height: this.canvasHeight,
					opacity: 0
				})
				this.canvasLayer.add(this.canvasBackPanel)
				this.canvasBackPanel.on('mouseover', this.onCanvasCancelSelection)
			}

			this.updateConnectionLines()
		},
		startConnectingFrom(area, index) {
			// 记录开始点
			this.connectingStartPoint = this.getKnobPosition(area, index)

			// 从左区开始连的，只允许往右， 反过来也是
			this.connectingFromArea = area

			// 开启onmousemove
			this.canvasStage.on('mousemove', this.onCanvasMouseMove)
		},
		onCanvasCancelSelection() {
			if (!this.selectedLine) return false

			// 重设
			let lines = this.canvasStage.find('Line')
			lines.each(l => {
				l.opacity(1)
			})

			// 去掉删除按钮
			this.selectedLine = null

			this.canvasStage.draw()
		},
		onCanvasMouseMove(e) {
			// 这里是点击线在移动过程
			let x = e.evt.offsetX
			let y = e.evt.offsetY

			let xDiff = x - this.connectingStartPoint.x

			if (this.connectingFromArea == 'left') {
				if (xDiff < 0) return
			} else {
				if (xDiff > 0) return
			}

			// 清理临时线
			if (this.canvasTempLine) {
				this.canvasTempLine.destroy()
				this.canvasTempLine = null
			}

			this.canvasTempLine = this.drawConnectionLine(
				this.connectingStartPoint.x,
				this.connectingStartPoint.y,
				x,
				y,
				'#FF5E2A',
				'solid',
				false,
				false
			)
		},
		drawConnectionLine(x1, y1, x2, y2, color, style, arcStyleStart, arcStyleFinish, skipDraw) {
			// 总是从左到右画
			let start = { x: x1, y: y1 }
			let end = { x: x2, y: y2 }
			if (x1 > x2) {
				// 翻转
				let tmp = start
				start = end
				end = tmp

				// 改入参，无品行为
				tmp = arcStyleStart
				arcStyleStart = arcStyleFinish
				arcStyleFinish = tmp
			}

			let points = [start.x, start.y]

			let midPoint = {
				x: Math.round((start.x + end.x) / 2),
				y: Math.round((start.y + end.y) / 2)
			}

			let diffY = Math.abs(end.y - start.y)
			let diffX = Math.abs(end.x - start.x)

			// 牵引点A -- 从开始点到中点，按抛物线公式  y = e^kx -1 来计算，算出k，然后计算出1/4 x位置的y
			let k1 = (2 * Math.log(diffY / 2 + 1)) / diffX
			let pointAYDiff = Math.pow(Math.E, (k1 * diffX) / 4) - 1

			points.push(Math.round(start.x + diffX / 4))
			points.push(Math.round(start.y + (end.y > start.y ? pointAYDiff : -pointAYDiff)))

			// 中点
			points.push(midPoint.x)
			points.push(midPoint.y)

			// 牵引点B -- 从中点到结束点，按抛物线公式   y = 1 - e^-kx 来计算，算出k，然后计算出1/4 x位置的y
			const MAX_RATE = 0.99
			let k2 = (-2 * Math.log(1 - MAX_RATE)) / diffX
			pointAYDiff = 1 - Math.pow(Math.E, (-k2 * diffX) / 4)
			pointAYDiff *= (1 / MAX_RATE) * (diffY / 2)

			points.push(Math.round(midPoint.x + diffX / 4))
			points.push(Math.round(midPoint.y + (end.y > start.y ? pointAYDiff : -pointAYDiff)))

			points.push(end.x)
			points.push(end.y)

			let retLine = new Konva.Line({
				points: points,
				stroke: color,
				strokeWidth: 1,
				hitStrokeWidth: 15,
				lineCap: 'round',
				lineJoin: 'round',
				tension: 0.3,
				height: 2
			})
			// let retLine = new Konva.Shape({
			//   sceneFunc: function (context, shape) {
			//     context.moveTo(points[0], points[1]);
			//     context.arcTo(points[2], points[3], points[6], points[7], 60);
			//     context.arcTo(points[6], points[7], points[8], points[9], 60);
			//     context.lineTo(points[8], points[9]);
			//     context.stroke();

			//     // (!) Konva specific method, it is very important
			//     context.fillStrokeShape(shape);
			//   },
			//   stroke: color,
			//   strokeWidth: 1
			// });
			if (style == 'dashed') {
				retLine.dash([15, 8])
			}

			this.canvasLayer.add(retLine)
			if (!skipDraw) this.canvasStage.draw()
			return retLine
		},
		updateConnectionLines() {
			this.canvasStage.find('Line').each(l => l.destroy())

			this.wrongConnections = []

			this.expanedConnections.forEach(el => {
				let start = this.getKnobPosition('left', el[0])
				let end = this.getKnobPosition('right', el[1])

				// 检查是否错选，决定颜色
				let color = '#FF5E2A'
				if (this.standardAnswer) {
					if (!this.expaneStandardAnswerConnections.find(stdEl => stdEl[0] === el[0] && stdEl[1] === el[1])) {
						// 标准答案连线内找不到，错选
						color = 'red'
						this.wrongConnections.push([parseInt(el[0]), parseInt(el[1])])
					}
				}

				if (!start || !end) return // 存在元素undefind , 打回

				let theLine = this.drawConnectionLine(start.x, start.y, end.x, end.y, color, 'solid', true, true, true)

				// 绑定一下click
				if (!this.disabled) {
					theLine.on('mouseover', this.handleCanvasLineMouseover)
				}
				theLine.id(el.join('_'))
			})

			// 找出漏选
			if (this.standardAnswer) {
				this.omitConnections = []
				this.expaneStandardAnswerConnections.forEach(el => {
					if (!this.expanedConnections.find(el2 => el2[0] === el[0] && el2[1] === el[1])) {
						// 找不到，这个楼选了
						//color = "red";
						this.omitConnections.push([parseInt(el[0]), parseInt(el[1])])

						let start = this.getKnobPosition('left', el[0])
						let end = this.getKnobPosition('right', el[1])

						if (!start || !end) return // 存在元素undefind , 打回
						this.drawConnectionLine(start.x, start.y, end.x, end.y, 'red', 'dashed', true, true, true)
					}
				})
			}
			this.canvasStage.draw()
		},
		handleCanvasLineMouseover(val) {
			// konva cancelBubble 在这里表现有点奇怪，我们用connectingFromArea 辨别能否hover 连线
			if (this.connectingFromArea) return
			this.selectedLine = val.currentTarget

			// 遍历没选中的， 设置透明度
			let lines = this.canvasStage.find('Line')
			lines.each(l => {
				if (l._id !== this.selectedLine._id) {
					l.opacity(0.1)
				} else {
					l.opacity(1)
				}
			})

			// 飘一个删除buttn到中点
			this.canvasStage.draw()
		},
		isKnobActive(area, index) {
			if (this.connectingKnob) {
				if (area == this.connectingKnob.area && index == this.connectingKnob.index) return true
			}

			let isActive = null
			let isActive2 = null

			// 处理漏选 active 样式
			if (this.omitConnections) {
				isActive = this.omitConnections.some(omitEl => {
					if (area == 'left') {
						return omitEl[0] === index
					} else {
						return omitEl[1] === index
					}
				})
			}

			// 检查是否存在于已经连好了的
			isActive2 = this.expanedConnections.some(el => {
				if (area == 'left') {
					return el[0] == index
				} else {
					return el[1] == index
				}
			})

			return isActive || isActive2
		},
		onChangeItem(area, index, value) {
			let newBranches = cloneDeep(this.items)
			newBranches[area][index] = value
			this.$emit('change-items', newBranches)
		},
		getKnobPosition(area, index) {
			// 获取某个连接点的中心XY值，用于canvas画图
			let knobName = 'knob_' + area
			let knobElm = this.$refs[knobName][index]
			if (!knobElm) return
			// element-resize-detector 会在监听容器上设置 position: relative，offsetLeft 数值会受影响。
			let x =
				area === 'right'
					? knobElm.offsetParent.offsetLeft + Math.floor(knobElm.offsetWidth / 2) + knobElm.offsetLeft
					: knobElm.offsetLeft + Math.floor(knobElm.offsetWidth / 2)
			let y = knobElm.offsetTop + Math.floor(knobElm.offsetHeight / 2)
			return { x, y }
		},
		onKnobEnter(area, index) {
			if (!this.connectingKnob) return
			if (area == this.connectingKnob.area) return // 同一边，无效，假装没发生

			// 修正临时线，粘上去的感觉
			if (!this.canvasTempLine) return // 不知道为啥，反正没有临时线

			let snapedPoint = this.getKnobPosition(area, index)

			this.canvasTempLine.destroy()
			this.canvasTempLine = this.drawConnectionLine(
				this.connectingStartPoint.x,
				this.connectingStartPoint.y,
				snapedPoint.x,
				snapedPoint.y,
				'#FF5E2A',
				'solid',
				true,
				true
			)
		},
		// 解除连线状态
		onRemoveLineBtn() {
			if (!this.selectedLine) return

			let line = this.selectedLine
			let lineEl = line.id().split('_')

			let newConnections = cloneDeep(this.expanedConnections)

			newConnections = newConnections.filter(el => {
				return el[0] !== parseInt(lineEl[0]) || el[1] !== parseInt(lineEl[1])
			})

			this.onCanvasCancelSelection()

			// 不需要手工删除线段，根据VUE的规矩，要emit出去，从外面设进来，不要随便修改内状态
			//line.destroy();
			//this.canvasStage.draw();

			// 通知
			this.$emit('change-connections', this.convertToMappedConnection(newConnections))
		},
		onAddItembtn(area) {
			// 加到底部，不需要担心connection问题
			let newBranches = cloneDeep(this.items)
			newBranches[area].push('')
			this.$emit('change-items', newBranches)
		},
		// 假如线还在连接中数据却被删除，需要更新全部数据
		onRemoveItemBtn(area, index) {
			// 维护item
			let newBranches = cloneDeep(this.items)
			newBranches[area].splice(index, 1)
			// 维护connection
			let newConnections = []
			this.expanedConnections.forEach(el => {
				if (area == 'left') {
					if (el[0] == index) return // 节点被删除了
					if (el[0] > index) newConnections.push([el[0] - 1, el[1]])
					else newConnections.push(el)
				} else {
					if (el[1] == index) return // 节点被删除了
					if (el[1] > index) newConnections.push([el[0], el[1] - 1])
					else newConnections.push(el)
				}
			})

			this.$emit('change-all', {
				items: newBranches,
				connections: this.convertToMappedConnection(newConnections)
			})
		},
		onClickKnob(area, index) {
			// 这个事件会触发两次，左到右，反之，从点击到结束
			if (this.disabled) return
			this.onCanvasCancelSelection()
			if (this.connectingKnob) {
				// 已经连接了一头了
				// 是否属于另外一边
				if (area == this.connectingKnob.area) return // 同一边，无效，假装没发生

				// 现在总是先删除临时线
				if (this.canvasTempLine) {
					this.canvasTempLine.destroy()
					this.canvasStage.draw()
				}

				let conn = []
				if (area == 'left') {
					conn.push(index)
					conn.push(this.connectingKnob.index)
				} else {
					conn.push(this.connectingKnob.index)
					conn.push(index)
				}

				// 清理连接中状态
				this.connectingKnob = null
				this.connectingStartPoint = null
				this.connectingFromArea = null

				// 解除事件
				this.canvasStage.off('mousemove', this.onCanvasMouseMove)

				// 查询是否已经有重复连线了，如果重复了，假装没发生。。。
				if (this.expanedConnections.some(el => el[0] === conn[0] && el[1] === conn[1])) return

				// 新增
				let newConnections = cloneDeep(this.expanedConnections)
				newConnections.push(conn)
				this.$emit('change-connections', this.convertToMappedConnection(newConnections))
				// this.convertToMappedConnection(newConnections)
			} else {
				// 刚开始连接
				this.connectingKnob = {
					area,
					index
				}

				this.startConnectingFrom(area, index)
			}
		}
	}
}
</script>

<style lang="scss">
.line-matching-answered-tips {
	max-width: 890px;
	margin: 0 auto;
	display: flex;
	justify-content: flex-end;
	.cell {
		font-size: 12px;
		color: #ff5e2a;
		margin-right: 16px;
		&.wrong {
			color: #ff0000;
		}
		&.miss {
			margin: 0 5px 0 0;
			color: #ff0000;
		}
		.icon {
			font-size: 16px;
			margin-right: 4px;
		}
	}
}
.line-matching-control {
	max-width: 890px;
	position: relative;
	display: flex;
	flex-direction: row;
	justify-content: space-between;

	.conn-canvas {
		position: absolute;
	}

	.canvas-line-remover {
		position: absolute;
		transition-property: opacity;
		z-index: 100;
	}

	.add-area-item-btn {
		z-index: 100;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.items-area {
		position: relative; // 主动设置 relative 定位，避免element-resize-detector 引起的连线跳动
		border-radius: 4px;
		padding: 15px 5px;
		// border: 1px dashed rgba(220, 223, 230, 1);
		// max-width: 416px;
		// min-width: 300px;
		width: 350px;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		z-index: 100;

		&.edit {
			border: 1px dashed rgba(220, 223, 230, 1);
		}
		.knob {
			box-shadow: 0 0 0 1.5px #cccccc;

			border-radius: 50%;
			.circle {
				width: 12px;
				height: 12px;
				border-radius: 50%;
				transition: border 0.3s;
				margin: 4px;

				&.active {
					background: #ff5e2a;
				}
			}

			&:hover {
				.circle {
					background: #ff5e2a;
				}
			}
		}

		&.left-area {
			.connect-mode-item {
				justify-content: flex-end;
				border-radius: 4px;
			}
		}

		&.right-area {
			.connect-mode-item {
				border-radius: 4px;
			}
		}

		.connect-mode-item {
			border: none;
			box-shadow: 0 0 0 1.5px #cccccc;

			.item {
				width: 80%;
				padding: 7px;
				display: flex;
				height: 200px;
				overflow: auto;
			}
			&.active {
				box-shadow: 0 0 0 1.5px #ff5e2a;
			}

			&.wrong-answered {
				border-color: red !important;

				.circle.active {
					background: red !important;
				}
			}
			&.wrong-answered_right {
				.circle.active {
					background: red !important;
				}
			}
		}

		.edit-mode-item,
		.connect-mode-item {
			display: flex;
			flex-direction: row;
			margin-bottom: 20px;
			// z-index: 100;
			align-items: center;

			&:last-of-type {
				margin-bottom: 0;
			}

			.item-qtext {
				width: 100%;
			}

			.remove-btn,
			.knob {
				display: flex;
				flex-direction: column;
				justify-content: space-around;
				margin: 10px;
				z-index: 100;
			}
			.remove-btn {
				button {
					width: 30px;
					height: 30px;
					background: #fff1f1;
					display: flex;
					justify-content: center;
					align-items: center;
					.icon {
						font-size: 16px;
					}
				}
			}
		}
	}
	.item-qtext {
		min-width: 250px;
	}
}
.icon-circle {
	width: 28px;
	height: 28px;
	// border-radius: 100%;
	background: #fff8f5;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
}
.quill-text {
	flex: 1;
	max-width: 330px;
	min-height: 97px;
}
</style>
